var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-trucking" },
    [
      _c(
        "tab-trucking-UICustom-layout",
        {
          staticStyle: { "min-width": "1200px" },
          attrs: {
            "element-blocks": _vm.elementBlocks,
            "to-exo-system-hc": _vm.toExoSystemHc
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "section",
              attrs: { slot: "haichuang" },
              slot: "haichuang"
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_VehicleInformation")) + " "
                ),
                !_vm.job.uuid
                  ? _c(
                      "span",
                      {
                        staticStyle: { color: "red", "font-weight": "lighter" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SeaExport.SaveBusinessBeforeEnterMultiGate")
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticStyle: { margin: "20px" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_DispatchVehicleNoteFields"))
                  )
                ]),
                _c(
                  "span",
                  { staticStyle: { color: "red", "font-weight": "bold" } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TTDEG")))]
                )
              ]),
              _c(
                "div",
                { staticStyle: { display: "flex", "padding-bottom": "5px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "addHcInfo",
                        type: "primary",
                        disabled: _vm.readonly || !_vm.job.uuid
                      },
                      on: { click: _vm.addHcInfoHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "delHcInfo",
                        disabled: _vm.readonly || !_vm.job.uuid,
                        type: "danger"
                      },
                      on: { click: _vm.delHcInfoHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", "padding-bottom": "5px" },
                attrs: {
                  no: "hcInfo",
                  "config-module": "20250522",
                  "grid-options": _vm.hcInfo.gridOptions,
                  "grid-params": _vm.hcInfo.gridParams,
                  "column-defs": _vm.hcInfoColumnDef,
                  "row-data": _vm.hcInfoTrucking
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.hcInfo, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.hcInfo, "gridParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.hcInfo.gridApi = params.api
                  }
                }
              }),
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Partners.doorInformation")) + " ")
              ]),
              _c(
                "div",
                { staticStyle: { display: "flex", "padding-bottom": "5px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "addHcDoor",
                        type: "primary",
                        disabled: _vm.readonly || !_vm.job.uuid
                      },
                      on: {
                        click: function($event) {
                          return _vm.addHcDoorHandler(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "delHcDoor",
                        disabled: _vm.readonly || !_vm.job.uuid,
                        type: "danger"
                      },
                      on: { click: _vm.delHcDoorHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "informationMaintenance",
                        disabled: _vm.readonly || !_vm.job.uuid,
                        type: "success"
                      },
                      on: { click: _vm.addDoor }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_InformationMaintenance"))
                      )
                    ]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  no: "hcInfo",
                  "config-module": "20250523",
                  "grid-options": _vm.hcDoor.gridOptions,
                  "grid-params": _vm.hcDoor.gridParams,
                  "column-defs": _vm.hcDoorColumDef,
                  "row-data": _vm.hcDoorTrucking
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.hcDoor, "gridParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.hcDoor, "gridParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.hcDoor.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          [
            _vm.showSecondSync || _vm.job.multiplePickups
              ? _c(
                  "div",
                  {
                    staticClass: "section",
                    attrs: { slot: "DoorToDoorLoading" },
                    slot: "DoorToDoorLoading"
                  },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.DoorToDoorLoading")) + " "
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "red",
                            "font-weight": "lighter",
                            margin: "30px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.SaveBusinessBeforeEnterMultiGate"
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column"
                        }
                      },
                      [
                        _vm.showSecondSync
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: _vm.syncToDischargingTruckingInfo
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.SecondarySynchronization"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.job.multiplePickups
                          ? _c(
                              "div",
                              [
                                _vm.top.visible
                                  ? _c("cargo-ag-grid", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        no: "1",
                                        "config-module": _vm.topConfigModuel,
                                        "grid-options": _vm.top.gridOptions,
                                        "grid-params": _vm.top.gridParams,
                                        "column-defs": _vm.topColumnDefs,
                                        "row-data": _vm.trucking
                                      },
                                      on: {
                                        "update:gridParams": function($event) {
                                          return _vm.$set(
                                            _vm.top,
                                            "gridParams",
                                            $event
                                          )
                                        },
                                        "update:grid-params": function($event) {
                                          return _vm.$set(
                                            _vm.top,
                                            "gridParams",
                                            $event
                                          )
                                        },
                                        gridReady: function(params) {
                                          _vm.topgridApi = params.api
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.job.multiplePickups
                          ? _c(
                              "div",
                              {
                                staticClass: "app-main-inner-row operations",
                                staticStyle: { padding: "5px 0" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.cooperateEdit,
                                        expression: "cooperateEdit"
                                      }
                                    ],
                                    staticClass: "triggers"
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              no: "2",
                                              type: "primary",
                                              disabled: _vm.readonly
                                            },
                                            on: { click: _vm.copyNewHandler }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.copyAndAddPoItems"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              no: "3",
                                              type: "primary",
                                              disabled: _vm.readonly
                                            },
                                            on: { click: _vm.addHandler }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("SeaExport.Add2"))
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              no: "4",
                                              disabled: !_vm.btnEnable.btDel,
                                              type: "danger"
                                            },
                                            on: { click: _vm.delHandler }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("SeaExport.Delete")
                                              ) + " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                )
              : _vm._e(),
            [
              _vm.elementDict.multiplePickups.viewable
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: { width: "auto" },
                      attrs: {
                        slot: "multiplePickups",
                        no: "5.1",
                        disabled:
                          _vm.readonly ||
                          _vm.action === "add" ||
                          !_vm.elementDict.multiplePickups.writable
                      },
                      on: { change: _vm.multiPickupsChangeHandler },
                      slot: "multiplePickups",
                      model: {
                        value: _vm.job.multiplePickups,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "multiplePickups", $$v)
                        },
                        expression: "job.multiplePickups"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.elementDict.multiplePickups.label) + " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.elementDict.multipleCabinets.viewable && _vm.multiTruckingShow
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: { width: "auto" },
                      attrs: {
                        slot: "multipleCabinets",
                        no: "5.2",
                        disabled:
                          _vm.readonly ||
                          _vm.action === "add" ||
                          !_vm.elementDict.multipleCabinets.writable
                      },
                      on: {
                        change: function($event) {
                          return _vm.changePickupsOrCabinets("Cabinets")
                        }
                      },
                      slot: "multipleCabinets",
                      model: {
                        value: _vm.job.multipleCabinets,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "multipleCabinets", $$v)
                        },
                        expression: "job.multipleCabinets"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.elementDict.multipleCabinets.label) +
                          " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.elementDict.quantityGrossWeightVolume.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "quantityGrossWeightVolume" },
                      slot: "quantityGrossWeightVolume"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.quantityGrossWeightVolume
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.quantityGrossWeightVolume.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input-number", {
                            staticStyle: {
                              width: "118px",
                              "margin-right": "5px",
                              "flex-grow": "1"
                            },
                            attrs: {
                              no: "6",
                              value: _vm.truckingInfo.quantity || undefined,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.quantityGrossWeightVolume
                                  .writable,
                              min: 0,
                              max: 999999,
                              precision: 0,
                              "controls-position": "right"
                            },
                            on: {
                              input: function(val) {
                                _vm.truckingInfo.quantity = val
                              }
                            }
                          }),
                          _c("el-input-number", {
                            staticStyle: {
                              width: "118px",
                              "margin-right": "5px",
                              "flex-grow": "1"
                            },
                            attrs: {
                              no: "7",
                              value: _vm.truckingInfo.weight || undefined,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.quantityGrossWeightVolume
                                  .writable,
                              min: 0,
                              max: 999999,
                              precision: 3,
                              "controls-position": "right"
                            },
                            on: {
                              input: function(val) {
                                _vm.truckingInfo.weight = val
                              }
                            }
                          }),
                          _c("el-input-number", {
                            staticStyle: { width: "118px", "flex-grow": "1" },
                            attrs: {
                              no: "8",
                              value: _vm.truckingInfo.cubage || undefined,
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.quantityGrossWeightVolume
                                  .writable,
                              min: 0,
                              max: 999999,
                              precision: 3,
                              "controls-position": "right"
                            },
                            on: {
                              input: function(val) {
                                _vm.truckingInfo.cubage = val
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.carryingCmp.viewable && !_vm.isSalesForSzfs
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "carryingCmp" },
                      slot: "carryingCmp"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.carryingCmp.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.carryingCmp.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-company-select", {
                        staticStyle: {
                          width: "400px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "9",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.carryingCmp.writable,
                          "method-params": { truckCmp: true, active: true },
                          "default-value": _vm.truckingInfo.carryingCmp || "",
                          "latest-used-data-key":
                            _vm.elementDict.carryingCmp.userCustomContent &&
                            _vm.elementDict.carryingCmp.userCustomContent
                              .recentlyUsedDropdownData
                              ? "seaBooking-carryingCmp"
                              : ""
                        },
                        on: {
                          change: function(p) {
                            _vm.truckingInfo.carryingCmp = p.value || 0
                            _vm.carryingCmpChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.driver.viewable && !_vm.isSalesForSzfs
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "driver" },
                      slot: "driver"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.driver.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.driver.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            disabled:
                              _vm.readonly || !_vm.elementDict.driver.writable,
                            no: "10",
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                            "allow-create": true,
                            clearable: true,
                            filterable: ""
                          },
                          on: {
                            change: function($event) {
                              return _vm.carryingContactsChangeHandler(
                                false,
                                false
                              )
                            },
                            blur: _vm.selectContactBlur
                          },
                          model: {
                            value: _vm.truckingInfo.driver,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "driver", $$v)
                            },
                            expression: "truckingInfo.driver"
                          }
                        },
                        _vm._l(_vm.carryingContacts, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.contactPerson,
                              value: item.contactPerson
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadingDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "loadingDate" },
                      slot: "loadingDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "loadingDate",
                        staticStyle: { width: "400px" },
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.loadingDate.writable,
                          no: "11",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "loadingDate",
                              null,
                              true,
                              true,
                              _vm.truckingInfo
                            )
                          }
                        },
                        model: {
                          value: _vm.truckingInfo.loadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                          },
                          expression: "truckingInfo.loadingDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.driverName.viewable && !_vm.isSalesForSzfs
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "driverName" },
                      slot: "driverName"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.driverName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.driverName.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.elementDict.driverName.writable,
                            no: "12",
                            placeholder: _vm.readonly
                              ? ""
                              : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                            "allow-create": true,
                            clearable: true,
                            filterable: ""
                          },
                          on: { change: _vm.driverInfomationsChangeHandler },
                          model: {
                            value: _vm.truckingInfo.driverName,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "driverName", $$v)
                            },
                            expression: "truckingInfo.driverName"
                          }
                        },
                        _vm._l(_vm.driverInfomations, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.driverName,
                              value: item.driverName
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.travelTime.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "travelTime" },
                      slot: "travelTime"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.travelTime.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.travelTime.label
                        },
                        slot: "label"
                      }),
                      _c("el-input-number", {
                        staticStyle: { width: "105px" },
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.travelTime.writable,
                          no: "13",
                          min: 0,
                          "controls-position": "right"
                        },
                        model: {
                          value: _vm.truckingInfo.travelHour,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "travelHour", $$v)
                          },
                          expression: "truckingInfo.travelHour"
                        }
                      }),
                      _c("span", { staticStyle: { margin: "10px" } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Hour")))
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "100px" },
                        attrs: {
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.travelTime.writable,
                          no: "14",
                          min: 0,
                          max: 59,
                          "controls-position": "right"
                        },
                        model: {
                          value: _vm.truckingInfo.travelMinute,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "travelMinute", $$v)
                          },
                          expression: "truckingInfo.travelMinute"
                        }
                      }),
                      _c("span", { staticStyle: { margin: "10px" } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.Minute")))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.doorMan.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "doorMan" },
                      slot: "doorMan"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.doorMan.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.doorMan.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          disabled:
                            _vm.readonly || !_vm.elementDict.doorMan.writable,
                          no: "15"
                        },
                        model: {
                          value: _vm.truckingInfo.doorMan,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                          },
                          expression: "truckingInfo.doorMan"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.doorAddr.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "doorAddr" },
                      slot: "doorAddr"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.doorAddr.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.doorAddr.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          disabled:
                            _vm.readonly || !_vm.elementDict.doorAddr.writable,
                          no: "16",
                          type: "textarea",
                          rows: 3
                        },
                        model: {
                          value: _vm.truckingInfo.doorAddr,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                          },
                          expression: "truckingInfo.doorAddr"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.zipCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "zipCode" },
                      slot: "zipCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.zipCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.zipCode.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          disabled:
                            _vm.readonly || !_vm.elementDict.zipCode.writable,
                          no: "zipCode"
                        },
                        model: {
                          value: _vm.truckingInfo.zipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "zipCode", $$v)
                          },
                          expression: "truckingInfo.zipCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.cityCode.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { slot: "cityCode" },
                      slot: "cityCode"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cityCode.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cityCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "160px" },
                            attrs: {
                              no: "17",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.cityCode.writable,
                              "tag-name":
                                _vm.$store.getters.language === "zh"
                                  ? "chineseName"
                                  : "englishName",
                              "tag-value": "code",
                              cache: false,
                              filterable: "",
                              "default-value": _vm.truckingInfo.cityCode,
                              "static-options": _vm.cityList,
                              placeholder: _vm.$t("SeaExport.PleaseSelect")
                            },
                            on: {
                              parentCallBack: function(p) {
                                return (_vm.truckingInfo.cityCode = p.value)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.palletSum.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "palletSum" },
                      slot: "palletSum"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.palletSum.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.palletSum.label
                        },
                        slot: "label"
                      }),
                      _c("el-input-number", {
                        staticStyle: { width: "140px" },
                        attrs: {
                          no: "18",
                          value: _vm.truckingInfo.palletSum,
                          disabled:
                            _vm.readonly || !_vm.elementDict.palletSum.writable,
                          min: 0,
                          max: 999999999999,
                          precision: 0,
                          controls: false
                        },
                        on: {
                          input: function(val) {
                            _vm.truckingInfo.palletSum = val || 0
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.po.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "po" }, slot: "po" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.po.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.po.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "po",
                          disabled:
                            _vm.readonly || !_vm.elementDict.po.writable,
                          "filter-chars": false,
                          type: "textarea",
                          rows: 3
                        },
                        model: {
                          value: _vm.truckingInfo.po,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "po", $$v)
                          },
                          expression: "truckingInfo.po"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.loadingAddress &&
              _vm.elementDict.loadingAddress.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "loadingAddress" },
                      slot: "loadingAddress"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.loadingAddress.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.loadingAddress.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "loadingAddress",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.loadingAddress.writable,
                          "filter-chars": false,
                          type: "textarea",
                          rows: 3
                        },
                        model: {
                          value: _vm.truckingInfo.loadingAddress,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "loadingAddress", $$v)
                          },
                          expression: "truckingInfo.loadingAddress"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.returnContainerAddress &&
              _vm.elementDict.returnContainerAddress.viewable
                ? _c(
                    "el-form-item",
                    {
                      attrs: { slot: "returnContainerAddress" },
                      slot: "returnContainerAddress"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.returnContainerAddress.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.returnContainerAddress.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "returnContainerAddress",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.returnContainerAddress.writable,
                          "filter-chars": false,
                          type: "textarea",
                          rows: 3
                        },
                        model: {
                          value: _vm.truckingInfo.returnContainerAddress,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.truckingInfo,
                              "returnContainerAddress",
                              $$v
                            )
                          },
                          expression: "truckingInfo.returnContainerAddress"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            [
              _vm.elementDict.soNo.viewable && _vm.job.multiplePickups
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "soNo" },
                      slot: "soNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.soNo.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.soNo.label
                        },
                        slot: "label"
                      }),
                      _c("so-no-selector", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          "so-no": _vm.soNo,
                          disabled:
                            _vm.readonly || !_vm.elementDict.soNo.writable
                        },
                        model: {
                          value: _vm.truckingInfo.soNo,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "soNo", $$v)
                          },
                          expression: "truckingInfo.soNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.truckOrderNo.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "truckOrderNo" },
                      slot: "truckOrderNo"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.truckOrderNo.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.truckOrderNo.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "19",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.truckOrderNo.writable
                        },
                        on: { change: _vm.refreshGrid },
                        model: {
                          value: _vm.truckingInfo.truckOrderNo,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "truckOrderNo", $$v)
                          },
                          expression: "truckingInfo.truckOrderNo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.truckingFee.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "truckingFee" },
                      slot: "truckingFee"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.truckingFee.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.truckingFee.label
                        },
                        slot: "label"
                      }),
                      _c("el-input-number", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "40",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.truckingFee.writable,
                          min: 0,
                          max: 999999999999,
                          precision: 2,
                          "controls-position": "right"
                        },
                        on: { change: _vm.truckingFeeCharge },
                        model: {
                          value: _vm.truckingInfo.truckingFee,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "truckingFee", $$v)
                          },
                          expression: "truckingInfo.truckingFee"
                        }
                      }),
                      _c("span", { staticStyle: { "padding-left": "10px" } }, [
                        _vm._v(_vm._s(_vm.localCurrency))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.driverTel.viewable && !_vm.isSalesForSzfs
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "driverTel" },
                      slot: "driverTel"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.driverTel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.driverTel.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "41",
                          disabled:
                            _vm.readonly || !_vm.elementDict.driverTel.writable
                        },
                        on: { change: _vm.refreshGrid },
                        model: {
                          value: _vm.truckingInfo.driverTel,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "driverTel", $$v)
                          },
                          expression: "truckingInfo.driverTel"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.actLoadingDate.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "actLoadingDate" },
                      slot: "actLoadingDate"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.actLoadingDate.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.actLoadingDate.label
                        },
                        slot: "label"
                      }),
                      _c("el-date-picker", {
                        ref: "actLoadingDate",
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "42",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.actLoadingDate.writable,
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm:ss"
                        },
                        on: {
                          blur: function() {
                            _vm.handleBlur(
                              "actLoadingDate",
                              null,
                              true,
                              true,
                              _vm.truckingInfo
                            )
                          }
                        },
                        model: {
                          value: _vm.truckingInfo.actLoadingDate,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "actLoadingDate", $$v)
                          },
                          expression: "truckingInfo.actLoadingDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.plateNumber.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "plateNumber" },
                      slot: "plateNumber"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.plateNumber.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.plateNumber.label
                        },
                        slot: "label"
                      }),
                      _vm.isEdit
                        ? _c("el-input", {
                            staticStyle: { width: "280px" },
                            attrs: {
                              no: "43",
                              disabled:
                                _vm.readonly ||
                                !_vm.elementDict.plateNumber.writable
                            },
                            on: {
                              input: function(val) {
                                _vm.truckingInfo.plateNumber = val.trim()
                              }
                            },
                            model: {
                              value: _vm.truckingInfo.plateNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "plateNumber", $$v)
                              },
                              expression: "truckingInfo.plateNumber"
                            }
                          })
                        : _vm._e(),
                      _vm.readonly
                        ? _c("span", { staticClass: "plate_number" }, [
                            _vm._v(_vm._s(_vm.truckingInfo.plateNumber))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.driverPhone.viewable && !_vm.isSalesForSzfs
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        slot: "driverPhone",
                        disabled: _vm.txtEditEable
                      },
                      slot: "driverPhone"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.driverPhone.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.driverPhone.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "45",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.driverPhone.writable
                        },
                        model: {
                          value: _vm.truckingInfo.driverPhone,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "driverPhone", $$v)
                          },
                          expression: "truckingInfo.driverPhone"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.doorName.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "doorName" },
                      slot: "doorName"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.doorName.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.doorName.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-repeat-value-select", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          placeholder: _vm.readonly
                            ? ""
                            : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                          filterable: "",
                          "allow-create": true,
                          disabled:
                            _vm.readonly || !_vm.elementDict.doorName.writable,
                          clearable: "",
                          options: _vm.doorList,
                          "label-field": "name",
                          "value-field": "name",
                          "unique-field": "uuid",
                          "match-of-repeat-value": _vm.matchOfRepeatDoor
                        },
                        on: { change: _vm.doorsChangeHandler },
                        model: {
                          value: _vm.truckingInfo.doorName,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorName", $$v)
                          },
                          expression: "truckingInfo.doorName"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.$checkPermission([
                                "button_Common_AddSite"
                              ]),
                              expression:
                                "$checkPermission(['button_Common_AddSite'])"
                            }
                          ],
                          staticClass: "vehicle-btn",
                          attrs: {
                            no: "addDoor",
                            disabled: !_vm.isEdit,
                            type: "primary",
                            size: "mini"
                          },
                          on: { click: _vm.addDoor }
                        },
                        [_vm._v(_vm._s(_vm.$t("Partners.doorInformation")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.doorManTel.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "doorManTel" },
                      slot: "doorManTel"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.doorManTel.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.doorManTel.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "46",
                          disabled:
                            _vm.readonly || !_vm.elementDict.doorManTel.writable
                        },
                        model: {
                          value: _vm.truckingInfo.doorManTel,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                          },
                          expression: "truckingInfo.doorManTel"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.remarks.viewable
                ? _c(
                    "el-form-item",
                    { attrs: { slot: "remarks" }, slot: "remarks" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.remarks.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "47",
                          disabled:
                            _vm.readonly || !_vm.elementDict.remarks.writable,
                          "filter-chars": false,
                          type: "textarea",
                          rows: 3
                        },
                        model: {
                          value: _vm.truckingInfo.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "remarks", $$v)
                          },
                          expression: "truckingInfo.remarks"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.elementDict.driverIdCard.viewable
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { slot: "driverIdCard" },
                      slot: "driverIdCard"
                    },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.driverIdCard.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.driverIdCard.label
                        },
                        slot: "label"
                      }),
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          no: "60",
                          disabled:
                            _vm.readonly ||
                            !_vm.elementDict.driverIdCard.writable
                        },
                        model: {
                          value: _vm.truckingInfo.driverIdCard,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "driverIdCard", $$v)
                          },
                          expression: "truckingInfo.driverIdCard"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          ],
          _vm.elementDict.containerInfo.viewable
            ? _c("template", { slot: "containerInfo" }, [
                !_vm.job.multipleCabinets
                  ? _c(
                      "div",
                      { staticClass: "app-main-inner-row operations" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cooperateEdit,
                                expression: "cooperateEdit"
                              }
                            ],
                            staticClass: "triggers"
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "48",
                                      type: "primary",
                                      disabled: !(
                                        _vm.btnEnable.grpTruckOrderBtns ||
                                        (_vm.toExoSystemHc &&
                                          _vm.job.trucking &&
                                          _vm.job.trucking.length > 0)
                                      )
                                    },
                                    on: { click: _vm.linkUsageClickHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.AddPackingInfo")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "49",
                                      type: "danger",
                                      disabled: !(
                                        _vm.btnEnable.grpTruckOrderBtns ||
                                        (_vm.toExoSystemHc &&
                                          _vm.job.trucking &&
                                          _vm.job.trucking.length > 0)
                                      )
                                    },
                                    on: { click: _vm.delLinkUsageClickHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.RemovePackingInfo")
                                      ) + " "
                                    )
                                  ]
                                ),
                                !_vm.btnEnable.grpTruckOrderBtns
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "50",
                                          type: "primary",
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.command1) + " ")]
                                    )
                                  : _vm._e(),
                                _vm.btnEnable.grpTruckOrderBtns
                                  ? _c(
                                      "el-dropdown",
                                      {
                                        staticStyle: { "padding-left": "5px" },
                                        attrs: {
                                          "split-button": "",
                                          type: "primary",
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.btnConnectedTruckClickHandler()
                                          },
                                          command: function(p) {
                                            _vm.command1 = p
                                            _vm.btnConnectedTruckClickHandler()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.command1) + " "
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: {
                                              slot: "dropdown",
                                              disabled: !_vm.btnEnable
                                                .grpTruckOrderBtns
                                            },
                                            slot: "dropdown"
                                          },
                                          [
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.DispatchTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.DispatchTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.ModifyTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.ModifyTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.RevokeTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.RevokeTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-item",
                                              {
                                                attrs: {
                                                  disabled: !_vm.btnEnable
                                                    .grpTruckOrderBtns,
                                                  command: _vm.$t(
                                                    "SeaExport.SearchTuckOrder"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "SeaExport.SearchTuckOrder"
                                                    )
                                                  ) + " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "51",
                                      disabled: !_vm.btnEnable
                                        .grpTruckOrderBtns,
                                      type: "primary"
                                    },
                                    on: {
                                      click: _vm.showTuckOrderLogClickHandler
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ShowTuckOrderLog")
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.job.multipleCabinets
                  ? _c(
                      "div",
                      { staticStyle: { "flex-grow": "1", padding: "10px" } },
                      [
                        _vm.gridVisible.dgUsage
                          ? _c("cargo-ag-grid", {
                              staticStyle: { width: "100%", height: "350px" },
                              attrs: {
                                "config-module": "130136",
                                no: "52",
                                "grid-options": _vm.gridOptions,
                                "grid-params": _vm.gridParams,
                                "column-defs": _vm.columnDefs,
                                "row-data": _vm.usages
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  _vm.gridParams = $event
                                },
                                "update:grid-params": function($event) {
                                  _vm.gridParams = $event
                                },
                                gridReady: function(params) {
                                  return (_vm.gridApi = params.api)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm.gridVisible.dgUsageG7
                          ? _c("cargo-ag-grid", {
                              staticStyle: { width: "100%", height: "350px" },
                              attrs: {
                                "config-module": "130137",
                                no: "53",
                                "grid-options": _vm.gridOptions,
                                "grid-params": _vm.gridParams,
                                "column-defs": _vm.columnDefsG7,
                                "row-data": _vm.usages
                              },
                              on: {
                                "update:gridParams": function($event) {
                                  _vm.gridParams = $event
                                },
                                "update:grid-params": function($event) {
                                  _vm.gridParams = $event
                                },
                                gridReady: function(params) {
                                  return (_vm.gridApi = params.api)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.job.multipleCabinets
                  ? _c(
                      "div",
                      { staticClass: "app-main-inner-row operations" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cooperateEdit,
                                expression: "cooperateEdit"
                              }
                            ],
                            staticClass: "triggers"
                          },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "addCabinets",
                                      type: "primary",
                                      disabled: !_vm.btnEnable.grpTruckOrderBtns
                                    },
                                    on: { click: _vm.linkTruckRecordHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.AddPackingInfo")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "removeCabinets",
                                      type: "danger",
                                      disabled: !_vm.btnEnable.grpTruckOrderBtns
                                    },
                                    on: { click: _vm.dellinkTruckRecordHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.RemovePackingInfo")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "exportPackingInfo",
                                      type: "primary",
                                      disabled: !_vm.btnEnable.grpTruckOrderBtns
                                    },
                                    on: { click: _vm.exportTruckExcelData }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ExportPackingInfo")
                                      ) + " "
                                    )
                                  ]
                                ),
                                _c(
                                  "el-upload",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "padding-left": "5px"
                                    },
                                    attrs: {
                                      action: "string",
                                      "http-request": _vm.importTruckDataExcel,
                                      "show-file-list": false,
                                      disabled: !_vm.btnEnable
                                        .grpTruckOrderBtns,
                                      accept: ".xls, .xlsx",
                                      "before-upload": _vm.beforeUploadUsage
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "importPackingInfo",
                                          type: "primary",
                                          disabled: !_vm.btnEnable
                                            .grpTruckOrderBtns
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "SeaExport.ImportPackingInfo"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "exportErrorExcel",
                                      type: "primary",
                                      disabled:
                                        !_vm.btnEnable.grpTruckOrderBtns ||
                                        !_vm.importExcelResultID
                                    },
                                    on: { click: _vm.exportErrorExcel }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.DownloadImportResults"
                                        )
                                      ) + " "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.job.multipleCabinets
                  ? _c(
                      "div",
                      { staticStyle: { "flex-grow": "1", padding: "10px" } },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "350px" },
                          attrs: {
                            no: "gridCabinets",
                            "grid-options": _vm.gridOptions,
                            "grid-params": _vm.gridParams,
                            "column-defs": _vm.cabinetColumnDefs,
                            "row-data": _vm.truckingRecords
                          },
                          on: {
                            "update:gridParams": function($event) {
                              _vm.gridParams = $event
                            },
                            "update:grid-params": function($event) {
                              _vm.gridParams = $event
                            },
                            gridReady: function(params) {
                              return (_vm.gridApi = params.api)
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        2
      ),
      _c("trucking-container-usage-link-dialog", {
        attrs: {
          visible: _vm.containerUsageDialog.visible,
          "job-uuid": _vm.job.uuid,
          "trucking-info-uuid": _vm.truckingInfo.uuid,
          "modify-usage-in-edit-mode": _vm.modifyUsageInEditMode,
          data: _vm.containerUsageDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.containerUsageDialog, "visible", $event)
          },
          selectContainerUsageHandler: _vm.selectContainerUsageHandler,
          saveContainerUsageData: _vm.saveContainerUsageHandler
        }
      }),
      _c("trucking-container-record-link-dialog", {
        attrs: {
          visible: _vm.containerTruckingRecordDialog.visible,
          "job-uuid": _vm.job.uuid,
          "trucking-info-uuid": _vm.truckingInfo.uuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(
              _vm.containerTruckingRecordDialog,
              "visible",
              $event
            )
          },
          selectTruckingRecordHandler: _vm.selectTruckingRecordHandler
        }
      }),
      _c("information-maintenance-dialog", {
        attrs: {
          visible: _vm.informationDialog.visible,
          site: _vm.informationDialog.site,
          title: _vm.informationDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.informationDialog, "visible", $event)
          },
          syncSiteToJob: _vm.syncSiteToJob,
          refresh: _vm.loadSites
        }
      }),
      _c("tuck-order-log-dialog", {
        attrs: {
          visible: _vm.truckOrderLogDialog.visible,
          "row-data": _vm.truckOrderLogDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.truckOrderLogDialog, "visible", $event)
          }
        }
      }),
      _c("error-log-dialog", {
        attrs: {
          visible: _vm.errorLogDialog.visible,
          "row-data": _vm.errorLogDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.errorLogDialog, "visible", $event)
          }
        }
      }),
      _c("upload-common-file", {
        attrs: {
          visible: _vm.uploadCommonFileDialog.visible,
          model: _vm.uploadCommonFileDialog.model
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadCommonFileDialog, "visible", $event)
          }
        }
      }),
      _c("door-point-information", {
        attrs: {
          "v-if": _vm.addDoorDialog.visible,
          visible: _vm.addDoorDialog.visible,
          "show-area": _vm.toExoSystemHc,
          action: _vm.action,
          site: _vm.addDoorDialog.form
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.addDoorDialog, "visible", $event)
          },
          loadSites: _vm.loadSites
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }